import { Classroom } from '@/api/classroom'
import { TransactionApi } from '@/api/transaction'

const state = () => ({
    privateWebinar: [],
    privateWebinarAvailable: [],
    privateWebinarRejected: [],
    loadingPrivateWebinar: false,
    messagePrivateWebinar: '',
    successPrivateWebinar: true,
    quotaPrice: null,
})

const getters = {
    privateWebinar: state => state.privateWebinar,
    privateWebinarAvailable: state => state.privateWebinarAvailable,
    privateWebinarRejected: state => state.privateWebinarRejected,
    loadingPrivateWebinar: state => state.loadingPrivateWebinar,
    messagePrivateWebinar: state => state.messagePrivateWebinar,
    successPrivateWebinar: state => state.successPrivateWebinar,
    quotaPrice: state => state.quotaPrice,
}

const actions = {
    async fetchAllPrivateWebinar({ commit }) {
        commit('setLoadingPrivateWebinar', true)
        await Classroom.getPrivateWebinar('')
        .then(res => {
            let privateWebinar = []
            if (res.data.data.length > 0) {
                res.data.data.forEach(el => {
                    const split = el.note.split(/\r\n|\n\r|\n|\r/)
                    privateWebinar.push({
                        ...el,
                        material: split[0],
                        reason: split[1],
                    })
                })
            }
            commit('setLoadingPrivateWebinar', false)
            commit('setPrivateWebinar', privateWebinar)
        })
        .catch(err => {
            commit('setMessagePrivateWebinar', err.errors[0].message)
            commit('setLoadingPrivateWebinar', false)
        })
    },
    async fetchAllPrivateWebinarAvailable({ commit }) {
        commit('setLoadingPrivateWebinar', true)
        await Classroom.getPrivateWebinar('available')
        .then(res => {
            let privateWebinar = []
            if (res.data.data.length > 0) {
                res.data.data.forEach(el => {
                    const split = el.note.split(/\r\n|\n\r|\n|\r/)
                    privateWebinar.push({
                        ...el,
                        material: split[0],
                        reason: split[1],
                    })
                })
            }
            commit('setLoadingPrivateWebinar', false)
            commit('setPrivateWebinarAvailable', privateWebinar)
        })
        .catch(err => {
            commit('setMessagePrivateWebinar', err.errors[0].message)
            commit('setLoadingPrivateWebinar', false)
        })
    },
    async fetchAllPrivateWebinarRejected({ commit }) {
        commit('setLoadingPrivateWebinar', true)
        await Classroom.getPrivateWebinar('reject')
        .then(res => {
            let privateWebinar = []
            if (res.data.data.length > 0) {
                res.data.data.forEach(el => {
                    const split = el.note.split(/\r\n|\n\r|\n|\r/)
                    privateWebinar.push({
                        ...el,
                        material: split[0],
                        reason: split[1],
                    })
                })
            }
            commit('setLoadingPrivateWebinar', false)
            commit('setPrivateWebinarRejected', privateWebinar)
        })
        .catch(err => {
            commit('setMessagePrivateWebinar', err.errors[0].message)
            commit('setLoadingPrivateWebinar', false)
        })
    },

    async fetchQuotaPrice({ commit }) {
        await TransactionApi.getPriceTopup()
        .then(res => {
            commit('setQuotaPrice', res.data.data)
        })
        .catch(err => {
            return err
        })
    },
}

const mutations = {
    setPrivateWebinar: (state, data) => {
        state.privateWebinar = data
    },
    setPrivateWebinarAvailable: (state, data) => {
        state.privateWebinarAvailable = data
    },
    setPrivateWebinarRejected: (state, data) => {
        state.privateWebinarRejected = data
    },
    setLoadingPrivateWebinar: (state, loading) => {
        state.loadingPrivateWebinar = loading
    },
    setMessagePrivateWebinar: (state, message) => {
        state.messagePrivateWebinar = message
    },
    setSuccessPrivateWebinar: (state, status) => {
        state.successPrivateWebinar = status
    },
    setQuotaPrice: (state, data) => {
        state.quotaPrice = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}